// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"audioplayer_audioPlayer__1krxe"};